import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';
import { AuthService } from '@app/shared/services/auth.service';
import { AppInsightsServiceDirective } from '@app/shared/services/app-insights.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PublicComponent implements OnInit {
  public companyLogo = `./assets/icons/headerlogo-${environment.tenant.trim().toLowerCase()}.png`;

  constructor(
    public headerFooterVisibilityService: HeaderFooterVisibilityService,
    public authService: AuthService,
    public appInsightsServiceDirective: AppInsightsServiceDirective,
    public overlayLoaderService: OverlayLoaderService,
  ) {}

  ngOnInit() {
    this.headerFooterVisibilityService.isFooterVisible = false;
  }
} 
